<script>
import OrdersHistory from "@/components/Orders/List";

export default {
  components: {
    OrdersHistory
  },

  props: {
    professional: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <orders-history
    v-if="professional"
    :user="{ type: professional.type, id: professional.id }"
  />
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Orders.vue